import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

const key = import.meta.env.VITE_REVERB_APP_KEY;

// Si no hay llave, creamos un objeto "mock" para que el resto del código no falle
export const echo = key 
    ? new Echo({
        broadcaster: 'reverb',
        key: key,
        wsHost: import.meta.env.VITE_REVERB_HOST || window.location.hostname,
        wsPort: import.meta.env.VITE_REVERB_PORT ?? 80,
        wssPort: import.meta.env.VITE_REVERB_PORT ?? 443,
        forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
        enabledTransports: ['ws', 'wss'],
    })
    : {
        channel: () => ({
            listen: function() { return this; },
            stopListening: function() { return this; }
        }),
        private: () => ({
            listen: function() { return this; },
            stopListening: function() { return this; }
        }),
        leave: () => {},
        leaveChannel: () => {}
    } as any;
